import React, { useEffect, useState } from "react";
import { Box } from "@material-ui/core";
import _ from "lodash";
import { useRouteMatch } from "react-router";

import withAuthority from "../../../../components/Auth/withAuthority";
import { getCookie } from "../../../../utils/cookies";
import { fetchAllFilterLocations } from "../../../../services/locationApp/locationFilterService";
import { ERROR_MESSAGE_UNEXPECTED_ERROR } from "../../../../utils/consts";
import DefaultAlert from "../../../../components/alerts/DefaultAlert";
import Authorities from "../../../../auth/authorities";
import { fetchAllDriverSessionReportInfo } from "../../../../services/salesApp/driverSessionSummaryReport";
import SaleReportOneDate from "../../../../components/common/SaleReportOneDate";
import HourlySalesReportNode from "./HourlySalesReportNode";
import SaleReport from "../../../../components/common/SaleReport";
import {
  hourlySalesFilterObject,
  salesItemsFilterObject,
} from "../../../../utils/consts/list";
import { fetchAllItemsReportVersion2Info } from "../../../../services/salesApp/itemsReportService";
import {
  fetchHourlySalesReport,
  fetchMonthlySalesReport,
  fetchWeeklySalesReport,
} from "../../../../services/salesApp/hourlySalesReport";

/**
 * MonthlySalesReport Component:
 *
 * This component manages the display of shift-related information and interactions,
 * including filtering, sorting, pagination, and error handling. It fetches data from
 * backend APIs and renders shift reports and lists accordingly. The component integrates
 * with user authentication to control access based on user permissions.
 */
const MonthlySalesReport: React.FunctionComponent<{}> = () => {
  const [driverSummaryNodeList, setDriverSummaryNodeList] = useState<any>([]);
  const [error, setError] = useState("");
  const [isLoadingPage, setIsLoadingPage] = useState(false);
  const [filterData, setFilterData] = useState("");
  const [filterDetails, setFilterDetails] = useState("");
  const [openFilterCard, setOpenFilterCard] = useState(false);
  const [locationSelectorList, setLocationSelectorList] = useState<any>([]);
  const [isGetLocationInfo, setIsGetLocationInfo] = useState(false);
  const [locationSelectedList, setLocationSelectedList] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const extractDateRange = (input: any) => {
    const parts = input.split(",");

    let startDate: any = null;
    let endDate: any = null;

    parts.forEach((part: any) => {
      const match = part.match(/date([<>]=)(\d{4}-\d{2}-\d{2})/);
      if (match) {
        const [, operator, date] = match;
        if (operator === ">=") {
          if (!startDate || date > startDate) {
            startDate = date;
          }
        } else if (operator === "<=") {
          if (!endDate || date < endDate) {
            endDate = date;
          }
        }
      }
    });

    return { startDate, endDate };
  };

  const match: any = useRouteMatch();
  const idToken = getCookie("idToken");

  const getAllFilterLocation = async () => {
    // Call the API to fetch all filter locations
    fetchAllFilterLocations("")
      .then((res) => {
        // If the request is successful
        let locationList: any = [];
        // Check if the response data is not empty
        if (!_.isEmpty(res.data.data)) {
          // Iterate over each location in the response data
          res.data.data.map((location: any) => {
            // Push location details to the locationList array
            locationList.push({
              id: location.id,
              label: location.businessDisplayName,
            });
          });
        }

        // Update the location selector list with fetched locations
        setLocationSelectorList(locationList);
        // Set the flag to indicate that location info is fetched
        setIsGetLocationInfo(true);
      })
      .catch(() => {
        // If an error occurs during fetching, handle it by setting an error message
        setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
      });
  };

  /* Get all shift information using API call and response data set to driverSummaryNodeList state. */
  const getShiftFilterInfo = async (filter: any) => {
    const startEndDate = extractDateRange(filter);
    setStartDate(startEndDate.startDate);
    setEndDate(startEndDate.endDate);
    try {
      // Call the API to fetch sale item report information
      const res = await fetchMonthlySalesReport(
        idToken,
        match.params.locationId,
        filter,
      );
      if (Object.values(res.data.data).length === 0) {
        setDriverSummaryNodeList({ id: 1 });
      } else {
        setDriverSummaryNodeList(res.data.data);
      }

      setIsLoadingPage(false);
      // getSaleItemReportInfoCombineModifierFalse(filter, basedOnShift, output);
      // Once the data is fetched successfully, call getGroupInfo to proceed with data processing
    } catch (err) {
      // If an error occurs during fetching, handle it by setting loading state and displaying error message
      setIsLoadingPage(false);
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
      setDriverSummaryNodeList({ id: 1 });
    }
  };

  useEffect(() => {
    getAllFilterLocation();
    document.title = "Sale - Monthly Sales Report";
  }, []);

  // Get filter data
  const handleFilterData = (filterData: any) => {
    // setIsLoadingPage(true);
    setFilterData(filterData);
    // getShiftFilterInfo(filterData);
  };

  const getReportUsingButton = () => {
    setIsLoadingPage(true);
    getShiftFilterInfo(filterData);
  };

  const handleOnClickText = () => {
    setOpenFilterCard(true);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const handleLocationSelectorTypingList = (searchName: any) => {};
  return (
    <>
      <Box>
        <SaleReport
          handleFilterData={handleFilterData}
          locationSelectorList={locationSelectorList}
          handleLocationSelectorTypingList={handleLocationSelectorTypingList}
          setFilterDetails={setFilterDetails}
          availableFilter={hourlySalesFilterObject}
          isOpenSkeletonLoading={isLoadingPage}
          nodeList={driverSummaryNodeList}
          filterDetails={filterDetails}
          title={""}
          isChart={false}
          isGetLocationInfo={isGetLocationInfo}
          isSaleItem={true}
          locationSelectedList={locationSelectedList}
          setLocationSelectedList={setLocationSelectedList}
          openFilterCard={openFilterCard}
          setOpenFilterCard={setOpenFilterCard}
          handleOnClickText={handleOnClickText}
          topic="Monthly Sales Report"
          isReport={true}
          isYearlyDateRange={true}
          isNeedDropdown={true}
          isNeedTimeout={true}
          isShowButton={true}
          getReportUsingButton={getReportUsingButton}
        >
          <HourlySalesReportNode
            isLoading={isLoadingPage}
            startDate={startDate}
            endDate={endDate}
            filterDetails={filterDetails}
            locationSelectedList={locationSelectedList}
            handleOnClickText={handleOnClickText}
            driverSummaryNodeList={driverSummaryNodeList}
          />
          {/* {!_.isEmpty(driverSummaryNodeList) && (
            <Pagination
              handleChangePaginationUsingSelector={
                handleChangePaginationUsingSelector
              }
              handleChangePaginationUsingPageNumber={
                handleChangePaginationUsingPageNumber
              }
              totalPages={totalPages}
              currentPage={currentPage}
              pageSize={pageSize}
              isShift={true}
              totalResult={totalResult}
            />
          )} */}
        </SaleReport>

        <DefaultAlert
          open={!!error}
          handleClose={() => setError("")}
          message={error}
          severity="error"
        />
      </Box>
    </>
  );
};

export default withAuthority(MonthlySalesReport, Authorities.SALE_READ);
